// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_3Hg1BFph3JK-zpg8luEFSf","iconWrapper":"_18Q7H5CB9o1E39rKYP02DX","title":"_1pTRfxxd4Z4qBiSnDDnFt4","subTitle":"_3wCw3z-iyiJooD4qQRhqdZ","text":"_3N9NnVz97meIr5aCLQdmJN","companyWrapper":"zzcqAjSXWjWEXkZ-nrjZ-","company":"_2oONB993jVOw-MYOf22wUR","infoCompanyWrapper":"_1RnKekIUf-M01Azu2IFp55","nameCompany":"_2RLj99RvdpdUIxhnNCP5VH","propertiesCompany":"_3CaE96R3W2wb3zLOn6dRlm","buttonWrapper":"_1qT9cnZ5qBdo-koHE0r5Sb","yes":"_35C1bTmHB-X6Te4ojE6b7F","no":"Qj9z_WEOVzazuOj1q-nfk"};


//////////////////
// WEBPACK FOOTER
// ./src/components/RealtorPublishContactCompany/RealtorPublishContactCompany.scss
// module id = 1758
// module chunks = 0